import React, { useRef } from "react"
import { useThree, useFrame } from "@react-three/fiber"

export default function VariableLight(props) {
  const light = useRef()

  const { viewport } = useThree()
  const { width, height } = viewport
  const positionX = width * 2
  const positionY = height * -0.25

  useFrame((state, dt) => {
      const time = state.clock.getElapsedTime()
      const frequency = 2.5
      const oscillation = Math.sin(time * frequency) * 2 + 3.5

      light.current.intensity = oscillation
  })

  return (
      <directionalLight
          ref={light}
          position={[positionX, positionY, 80]}
          intensity={4.5}
      />
  )
}